module.exports = __webpack_public_path__ + "static/media/entrepreneurial-ecosystem-cropped.ef21bdd2.jpg";